// 交易核查状态
export const checkStatusMap = {
  CANCEL: '客户已取消',
  WAIT: '审核中',
  HOLD: '审核中',
  REJECT: '申报拒绝',
  PASS: '申报完成',
  PASS1: '审核中',
  PASS2: '申报完成',
  REFUND: '已退款'
}

// 汇款方企业性质
export const payBusinessTypeMap = {
  0: '投资公司',
  1: '贸易公司',
  2: '咨询公司',
  6: '物流、广告服务公司',
  7: '电子商务平台',
  8: '支付公司',
  9: '金融机构',
  10: '信托',
  11: '个人'
}

// 与汇款方关系
export const relationshipMap = {
  6: '投资方',
  7: '母公司/股东注资',
  8: '贸易往来客户',
  9: '咨询服务客户',
  10: '电商平台',
  11: '电信互联网运营服务商',
  12: '投资/理财服务',
  13: '其他'
}
